import {
  getSchema as getSchema1,
  getValidate as getValidate1,
  uiSchema as uiSchema1,
} from "./schema.editPropertyExtraInfo.1";
import { IExtraData } from "./schema.editPropertyExtraInfo.types";
import { getInitialValues } from "./schema.editPropertyExtraInfo.utils";

// eslint-disable-next-line import/no-default-export
export default (extraData: IExtraData) => {
  const initialValues = getInitialValues(extraData);
  return [
    {
      schema: getSchema1(initialValues, extraData),
      uiSchema: uiSchema1(initialValues, extraData),
      validate: getValidate1(extraData),
    },
  ];
};
